import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["item", "index"];
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import Box from '@rexlabs/box';
import { useStyles, StyleSheet, text, margin } from '@rexlabs/styling';
import { OptionContainer } from './container';
import { HighlightedLabel } from './highlighted-label';
var defaultStyles = StyleSheet({
  avatar: _objectSpread({}, margin.styles({
    target: 'select.option.avatar',
    right: 'xs'
  })),
  description: _objectSpread({
    wordBreak: 'break-word'
  }, text.styles({
    target: 'select.option.description',
    fallback: 'small.default',
    color: function color(_ref) {
      var token = _ref.token;
      return token('color.textStyle.body.subtext');
    }
  })),
  descriptionIndent: _objectSpread({}, margin.styles({
    target: 'select.option.description',
    left: function left(_ref2) {
      var _context;

      var token = _ref2.token;
      return _concatInstanceProperty(_context = "calc(".concat(token('icon.size.m'), " + ")).call(_context, token('select.option.icon.margin.right', token('spacing.xs')), ")");
    }
  })),
  icon: _objectSpread({}, margin.styles({
    target: 'select.option.icon',
    right: 'xs'
  }))
});
export var RecordOption = /*#__PURE__*/forwardRef(function RecordOption(_ref3, ref) {
  var item = _ref3.item,
      index = _ref3.index,
      props = _objectWithoutProperties(_ref3, _excluded);

  var s = useStyles(defaultStyles);
  var label = item.label,
      description = item.description,
      _item$avatar = item.avatar,
      avatar = _item$avatar === void 0 ? null : _item$avatar,
      Icon = item.Icon;
  var showIcon = !!(!avatar && Icon);
  return /*#__PURE__*/React.createElement(OptionContainer, _extends({}, props, {
    ref: ref,
    item: item,
    index: index,
    alignItems: "center"
  }), /*#__PURE__*/React.createElement(Box, {
    alignItems: "center"
  }, avatar && /*#__PURE__*/React.createElement(Box, _extends({}, s('avatar'), {
    alignItems: "center",
    justifyContent: "center"
  }), avatar), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    alignItems: "center"
  }, showIcon ? Icon && /*#__PURE__*/React.createElement(Icon, _extends({}, s('icon'), {
    size: "m"
  })) : null, /*#__PURE__*/React.createElement(HighlightedLabel, null, label)), description && /*#__PURE__*/React.createElement("div", s('description', {
    descriptionIndent: showIcon
  }), description))));
});